import { render, staticRenderFns } from "./file-download-ring.vue?vue&type=template&id=87209276&scoped=true&"
import script from "./file-download-ring.vue?vue&type=script&lang=js&"
export * from "./file-download-ring.vue?vue&type=script&lang=js&"
import style0 from "./file-download-ring.vue?vue&type=style&index=0&id=87209276&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87209276",
  null
  
)

export default component.exports